import { createContext } from 'react';
import { TApi } from 'utils/api';

export type TProjectConfigurationParameter = {
  key: string;
  value: string;
};

export type TData = {
  regionId: string;
  catalogueLevel: number;
  projectConfigurationParameters?: Array<TProjectConfigurationParameter>;
  type: string;
  env: {
    ORCHESTRATOR_HOST: string;
    API_KEY: string;
  };
  api: TApi;
};

export const DataContext = createContext<TData | null>(null);
